export default {
  chat: {
    yourChatListWillAppearHere: "Your chat list will appear here",
    startNewChat: "Start New Chat",
    voiceRecord: "Voice Record",
    voiceRecording: "Voice Recording",
  },
}
